import Vue from "vue"
import VueRouter from "vue-router"
import VueClipboard from 'vue-clipboard2'


import moment from "@/utils/moment"
import numeral from "@/utils/numeral"

import App from "./app.vue"
import router from "./router"
import store from "./store"
import errorHandler from "./services/error-handler"
import { branchName, cloneObject, truncateString, Scroll } from "./utils"

Vue.config.productionTip = false

Vue.prototype.$branchName = branchName
Vue.prototype.$errorHandler = errorHandler
Vue.prototype.$cloneObject = cloneObject
Vue.prototype.$truncateString = truncateString
Vue.prototype.$scroll = Scroll

Vue.prototype.$historyBack = () => { window.history.back() }

Vue.prototype.$formatDate = (date) => date ? moment(date).format("DD/MM/YYYY") : ""
Vue.prototype.$formatInteger = (value) => numeral(value).format("0,0")
Vue.prototype.$formatCurrency = (value) => numeral(value).format("0,0.00")
Vue.prototype.$formatCurrencyWith4Decimals = (value) => numeral(value).format("0,0.0000")

Vue.prototype.$isAdministrator = () => store.state.user.isAdministrator
Vue.prototype.$isApprover = () => store.state.user.isApprover
Vue.prototype.$isSeller = () => store.state.user.isSeller
Vue.prototype.$isCustomer = () => store.state.user.isCustomer
Vue.prototype.$isProspect = () => store.state.user.isProspect
Vue.prototype.$isCustomerOrProspect = () => (store.state.user.isProspect || store.state.user.isCustomer) 

Vue.use(VueClipboard)
Vue.use(VueRouter)

new Vue({
  router,
  store,
  render: (createElement) => createElement(App),
}).$mount("#app")
